export default function FavouriteBookmark({ includes }) {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.88 119.89">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path
              d="M58.6,29.81v-.06A11,11,0,0,0,47.87,18.48H47.6a9.5,9.5,0,0,0-9.26,7,.66.66,0,0,1-.62.44.63.63,0,0,1-.62-.44,9.51,9.51,0,0,0-9.27-7,11,11,0,0,0-11,11v.33c0,1.5.2,14.66,20.89,25.52,20.67-10.86,20.88-24,20.88-25.5Z"
              fill="#96323d"
            />
            <path
              d="M54.91,32.08h0a9,9,0,0,0-8.84-9.16H46a7.73,7.73,0,0,0-7.53,5.69.53.53,0,0,1-.68.32.51.51,0,0,1-.32-.32,7.75,7.75,0,0,0-7.54-5.69A9,9,0,0,0,21,32v.15c0,1.21.16,11.92,17,20.74,16.81-8.82,17-19.53,17-20.72Z"
              fill={includes > 0 ? "#96323d" : "#86a8a5"}
            />
            <path
              d="M.65,0,0,119.89,37.39,77.54l38.49,40.4V0ZM56,32.07c0,1.27-.16,12.62-17.74,21.75a.58.58,0,0,1-.22.08h-.07a.52.52,0,0,1-.29-.09C20.08,44.68,19.88,33.34,19.91,32.07V32a10,10,0,0,1,9.86-10.14h.14a8.72,8.72,0,0,1,8,5.13,8.72,8.72,0,0,1,8-5.13,10,10,0,0,1,10,10v.21H56Z"
              fill="#86a8a5"
            />
          </g>
        </g>
      </svg>
    </div>
  )
}
